import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import * as Styles from './UserImage.styles';

const UserImage = () => {
  const data = useStaticQuery(graphql`
    {
      file(name: { eq: "Jacek-Lewandowski" }) {
        childImageSharp {
          gatsbyImageData(placeholder: TRACED_SVG, width: 200)
        }
      }
      icons: allFile(
        filter: { relativeDirectory: { eq: "Icons" } }
        sort: { fields: name, order: ASC }
      ) {
        edges {
          node {
            publicURL
            name
          }
        }
      }
    }
  `);
  return (
    <Styles.UserContainer>
      <Styles.UserImageContainer>
        <a
          href='https://www.instagram.com/jacek.lewandowski_zonatapety/'
          target='_blank'
          rel='noreferrer'>
          <GatsbyImage
            image={data.file.childImageSharp.gatsbyImageData}
            alt='Jacek Lewandowski - ZONA Najpiękniejsze tapety w Koszalinie'
          />
        </a>
      </Styles.UserImageContainer>
      <Styles.UserContent>
        <p>
          Za pomiar, wykonanie i zachowanie najwyższej jakości odpowiada Jacek
          Lewandowski. <br />
        </p>
        <a
          href='https://www.instagram.com/jacek.lewandowski_zonatapety/'
          target='_blank'
          rel='noreferrer'>
          <Styles.IGIcon src={data.icons.edges[2].node.publicURL} />
        </a>
      </Styles.UserContent>
    </Styles.UserContainer>
  );
};

export default UserImage;
